import React from 'react';
import { Link } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

//TODO: Mergear GenericModalButton en webcore
import { GenericSimpleButton/*, GenericModalButton */ } from 'com-gyf-webcore-userinterfacecomponents';
import GenericModalButton from '../../../Packages/SharedComponents/Com.Gyf.WebCore.GenericModalButton';

import History from './History';

const Header = (props) => {
    let onClick;
    let component;

    if (props.historial.length > 0) {
        onClick = props.saveChanges;
        component = <GenericModalButton text="Cancelar" buttonClass="btn btn-secondary" dataTarget="#discardChangesModal" />;
    }
    else {
        onClick = props.errorSave;
        component =
            <Link to={ProcessManager.GetNextStep("EditarPermisos", "ROUTE_TO_PERFYPERM")}>
                <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" />
            </Link>;
    }

    return (
        <div className="row">
            <div className="col-xs-4">
                <div className="row">
                    <div className="col-xs-5">
                        <button className="btn btn-cta" onClick={() => onClick()}>Guardar</button>
                    </div>
                    <div className="col-xs-7">
                        {component}
                    </div>
                </div>
            </div>
            <div className="col-xs-8">
                <History historial={props.historial}
                    deleteHistorial={props.deleteHistorial}
                    selectHistorial={props.selectHistorial} />
            </div>
        </div>
    );
}

export default Header;